import React from "react";
import clsx from "clsx";
import { Button, ButtonProps } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import FiltersArrowsSort from "../coach-clients/FiltersArrowsSort";
import { ComponentTemplateSort } from "@growth-machine-llc/stridist-api-client";

interface ComponentNameSortButtonProps extends ButtonProps {
  sort: ComponentTemplateSort;
  onChangeSort?: (sort: ComponentTemplateSort) => void;
}

const useStyles = makeStyles((theme) => ({
  root: {
    fontWeight: "bold",
    fontSize: 15,
    textTransform: "none",
    padding: 0,
    minWidth: "auto",
    "&:hover": { backgroundColor: "transparent" },
  },
  active: {
    color: theme.palette.primary.main,
  },
  inactive: {
    color: theme.palette.text.primary,
  },
}));

export const ComponentNameSortButton = ({
  sort,
  onChangeSort,
  className,
  ...other
}: ComponentNameSortButtonProps) => {
  const s = useStyles();

  const isActiveAsc = sort === ComponentTemplateSort.NAME_ASC;
  const isActiveDesc = sort === ComponentTemplateSort.NAME_DESC;
  const isActive = isActiveAsc || isActiveDesc;

  const handleClick = () => {
    let nextSort: ComponentTemplateSort;

    if (!isActiveAsc && !isActiveDesc) {
      nextSort = ComponentTemplateSort.NAME_ASC;
    } else if (isActiveAsc) {
      nextSort = ComponentTemplateSort.NAME_DESC;
    } else {
      nextSort = null;
    }

    onChangeSort?.(nextSort);
  };

  return (
    <Button
      {...other}
      className={clsx(s.root, className, {
        [s.active]: isActive,
        [s.inactive]: !isActive,
      })}
      endIcon={
        <FiltersArrowsSort activeUp={isActiveAsc} activeDown={isActiveDesc} />
      }
      onClick={handleClick}
      disableRipple
    >
      Name
    </Button>
  );
};
